const e = typeof window < "u" ? window : null, t = ((e == null ? void 0 : e.requestAnimationFrame) || (e == null ? void 0 : e.webkitRequestAnimationFrame) || (e == null ? void 0 : e.mozRequestAnimationFrame) || (e == null ? void 0 : e.msRequestAnimationFrame) || (e == null ? void 0 : e.oRequestAnimationFrame) || // Fallback, but not a true polyfill
// Only needed for Opera Mini
((n) => setTimeout(n, 16))).bind(e);
export {
  t as r
};
